import { MouseEvent } from 'react';

import { MinusIcon, PlusIcon } from '@braskai/icons';
import { IconButton, Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

type BoosterSeatsCounterProps = {
  seatsCount: number;
  variant?: 'bordered' | 'default';
  onDecrement: (e: MouseEvent) => void;
  onIncrement: (e: MouseEvent) => void;
};

export const BoosterSeatsCounter = ({
  seatsCount,
  variant = 'default',
  onDecrement,
  onIncrement,
}: BoosterSeatsCounterProps) => {
  if (variant === 'bordered') {
    return (
      <Stack
        sx={{
          border: '1px solid',
          borderColor: 'grey.300',
          borderRadius: 8,
        }}
        alignItems="center"
        direction="row"
        gap={1}
        justifyContent="center"
      >
        <Stack
          sx={{
            alignItems: 'center',
            borderRight: '1px solid',
            borderRightColor: 'grey.300',
            height: '100%',
            justifyContent: 'center',
            paddingX: 8,
          }}
        >
          <IconButton
            data-testid="booster-seats-counter-decrement"
            disabled={seatsCount <= 1}
            size="sm"
            disableFixSizeIcon
            onClick={onDecrement}
          >
            <MinusIcon height={16} width={16} />
          </IconButton>
        </Stack>

        <Stack paddingX={12} paddingY={10}>
          <Typography color="grey.700" sx={{ minWidth: '20px', textAlign: 'center' }} variant="body-2-md">
            {seatsCount}
          </Typography>
        </Stack>

        <Stack
          sx={{
            alignItems: 'center',
            borderLeft: '1px solid',
            borderLeftColor: 'grey.300',
            height: '100%',
            justifyContent: 'center',
            paddingX: 8,
          }}
        >
          <IconButton
            data-testid="booster-seats-counter-increment"
            size="sm"
            disableFixSizeIcon
            onClick={onIncrement}
          >
            <PlusIcon height={16} width={16} />
          </IconButton>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack alignItems="center" alignSelf="flex-end" direction="row" spacing={1}>
      <IconButton
        sx={{
          backgroundColor: 'primary.100',
          color: 'primary.300',
          padding: 2,
        }}
        data-testid="booster-seats-counter-decrement-2"
        disabled={seatsCount <= 1}
        size="sm"
        disableFixSizeIcon
        onClick={onDecrement}
      >
        <MinusIcon height={16} width={16} />
      </IconButton>
      <Typography color="grey.700" sx={{ minWidth: '20px', textAlign: 'center' }} variant="body-2-md">
        {seatsCount}
      </Typography>
      <IconButton
        sx={{
          backgroundColor: 'primary.100',
          color: 'primary.600',
          padding: 2,
        }}
        data-testid="booster-seats-counter-increment-2"
        size="sm"
        disableFixSizeIcon
        onClick={onIncrement}
      >
        <PlusIcon height={16} width={16} />
      </IconButton>
    </Stack>
  );
};
